export default "__VITE_ASSET__DdSgbADr__"